(() => {
  const key = '__aliencellHalloweenPolicies';
  if (window[key]) {
    window[key].init(document);
    return;
  }
  const instances = new Map();
  const init = (scope) => {
    const roots = [...scope.querySelectorAll('[data-halloween-footer]')];
    if (scope.matches?.('[data-halloween-footer]')) roots.unshift(scope);
    roots.forEach((root) => {
      if (instances.has(root)) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      let active = null;
      let opener = null;
      let previousOverflow = null;
      let closeTimer = null;
      let closingModal = null;
      let openFrame = null;
      const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const resetClosing = () => {
        window.clearTimeout(closeTimer);
        closeTimer = null;
        if (closingModal) {
          closingModal.hidden = true;
          closingModal.style.display = 'none';
          closingModal = null;
        }
      };
      const close = (restoreFocus = true) => {
        if (!active) return;
        if (openFrame !== null) window.cancelAnimationFrame(openFrame);
        openFrame = null;
        resetClosing();
        const modal = active;
        const focusTarget = opener;
        const container = modal.querySelector('[data-halloween-policy-container]');
        container.classList.remove('a-model-transition-end');
        container.classList.add('a-model-transition-start');
        opener?.setAttribute('aria-expanded', 'false');
        active = null;
        if (previousOverflow !== null) document.documentElement.style.overflow = previousOverflow;
        previousOverflow = null;
        opener = null;
        const finish = () => {
          modal.hidden = true;
          modal.style.display = 'none';
          closingModal = null;
          closeTimer = null;
          if (restoreFocus && focusTarget?.isConnected) focusTarget.focus();
        };
        if (!restoreFocus || reducedMotion()) finish();
        else {
          closingModal = modal;
          closeTimer = window.setTimeout(finish, 200);
        }
      };
      root.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-halloween-policy-open]');
        if (trigger) {
          const modal = root.querySelector(`[id="${CSS.escape(trigger.dataset.halloweenPolicyOpen)}"]`);
          if (!modal) return;
          close(false);
          resetClosing();
          opener = trigger;
          opener.setAttribute('aria-expanded', 'true');
          active = modal;
          previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          active.hidden = false;
          active.style.display = 'flex';
          const container = modal.querySelector('[data-halloween-policy-container]');
          container.classList.remove('a-model-transition-end');
          container.classList.add('a-model-transition-start');
          openFrame = window.requestAnimationFrame(() => {
            openFrame = null;
            container.classList.remove('a-model-transition-start');
            container.classList.add('a-model-transition-end');
            modal.querySelector('[data-halloween-policy-close]')?.focus();
          });
        } else if (event.target.closest('[data-halloween-policy-close]') || event.target === active) {
          close();
        }
      }, options);
      document.addEventListener('keydown', (event) => {
        if (!active) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = [...active.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter((element) => element.getClientRects().length);
        if (!focusable.length) {
          event.preventDefault();
          active.focus();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || !active.contains(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !active.contains(document.activeElement))) {
          event.preventDefault();
          first.focus();
        }
      }, options);
      document.addEventListener('focusin', (event) => {
        if (active && !active.contains(event.target)) active.querySelector('[data-halloween-policy-close]')?.focus();
      }, options);
      instances.set(root, () => {
        close(false);
        resetClosing();
        if (openFrame !== null) window.cancelAnimationFrame(openFrame);
        controller.abort();
        instances.delete(root);
      });
    });
  };
  window[key] = { init };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((destroy, root) => {
      if (event.target.contains(root)) destroy();
    });
  });
  init(document);
})();
